import { PublicKey } from "@solana/web3.js"
import { NetworkType } from "./types"

export class Constants {
  static readonly CONFIG_SEED = "CONFIG"
  static readonly VAULT_SEED = "VAULT"
  static readonly AUTHORITY_SEED = "AUTHORITY"
  static readonly CAMPAIGN_SEED = "CAMPAIGN"
  static readonly ELIGIBLE_USERS_SEED = "ELIGIBLE_USERS"
  static readonly REPAY_DEBT_VOUCHER_SEED = "REPAY_DEBT_VOUCHER"
  static readonly BORROW_FEE_VOUCHER = "BORROW_FEE_VOUCHER"
  static readonly VOUCHER_NFT_PROGRAM_ID = new PublicKey("FhCJ9GkJ9zmNjFEc6tE1GpfRB8hTXTnT3HFw6WGULUwF")
  static readonly TOKEN_METADATA_PROGRAM = new PublicKey("metaXfaoQatFJP9xiuYRsKkHYgS5NqqcfxFbLGS5LdN")
  static readonly SOLANA_TOKEN_METADATA_PROGRAM = new PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")

  static readonly ONCHAIN_ADDRESS: {
    [key in NetworkType]: { lendingProgramId: PublicKey; lendingMarketAddress: PublicKey }
  } = {
    [NetworkType.SolanaDevnet]: {
      lendingProgramId: new PublicKey("3T3SKcgx6bYX69hNQUbrfDfejbfpzn8gge9mGu39TYkY"),
      lendingMarketAddress: new PublicKey("8CkJkMf2h3zst6Kxja8XxMNEfmscvCTh7QJvvFNcydvJ"),
    },
    [NetworkType.SolanaMainnet]: {
      lendingProgramId: new PublicKey("9L193MV4yakKcgNT2tN4Kvf1ypn9c1sVMvsRn1Amw2Au"),
      lendingMarketAddress: new PublicKey("GqCXjw24DiMjHoPFK2XPuUduKjjjPoLV575LPdTvnsJE"),
    },
    [NetworkType.TestNet]: {
      lendingProgramId: new PublicKey("LP17qXm5XnefkyVzkJa8gLcKXnjmsjX3YQCdB18Dsku"),
      lendingMarketAddress: new PublicKey("EcyDtNp9F5gpbRxk243EstrkvxmgNYrG1qmctWdfYMrw"),
    },
    [NetworkType.MainNet]: {
      lendingProgramId: new PublicKey("AqR1WSUwNeVsz66ayH2J8iTyiGMgouRwPqzzMaxx49ba"),
      lendingMarketAddress: new PublicKey("48qby9KswHa1dWa6xYKSYPju3oidfG6aZqDn8jSfpbcR"),
    },
    [NetworkType.LocalNet]: {
      lendingProgramId: new PublicKey("LP17qXm5XnefkyVzkJa8gLcKXnjmsjX3YQCdB18Dsku"),
      lendingMarketAddress: new PublicKey("EcyDtNp9F5gpbRxk243EstrkvxmgNYrG1qmctWdfYMrw"),
    },
    [NetworkType.SolanaTestNet]: {
      lendingProgramId: new PublicKey("3T3SKcgx6bYX69hNQUbrfDfejbfpzn8gge9mGu39TYkY"),
      lendingMarketAddress: new PublicKey("8CkJkMf2h3zst6Kxja8XxMNEfmscvCTh7QJvvFNcydvJ"),
    },
    [NetworkType.SolanaLocalNet]: {
      lendingProgramId: new PublicKey("3T3SKcgx6bYX69hNQUbrfDfejbfpzn8gge9mGu39TYkY"),
      lendingMarketAddress: new PublicKey("8CkJkMf2h3zst6Kxja8XxMNEfmscvCTh7QJvvFNcydvJ"),
    },
  }
}
